import { useEffect, useState } from 'react';
import { CrmisFeatureFlags, Tenant } from '../api/getCrmisFeatureFlags';
import useCrmisFeatureFlags from './useCrmisFeatureFlags';

export interface CrmisCountryFlags {
  eReceiptAvailable: boolean;
  signUpAvailable: boolean;
  memberIdAvailable: boolean;
  configuration: boolean;
  membershipAndLoyalty: boolean;
  signupQrcodeIdentification: boolean;
  [key: string]: boolean;
}

const useCountryFeatureFlags = (countryCode: string, tenant?: Tenant): { countryFlags?: CrmisCountryFlags, loading: boolean, error: boolean } => {
  const { featureFlags, loading: allFeaturesLoading, error } = useCrmisFeatureFlags(tenant);
  const [loading, setLoading] = useState<boolean>(allFeaturesLoading);
  const [ countryFlags, setCountryFlags] = useState<CrmisCountryFlags | undefined>(extractCountryFlags(countryCode, featureFlags));

  useEffect(() => {
    setLoading(true);
    const newFlags = extractCountryFlags(countryCode, featureFlags);
    setCountryFlags(newFlags);
    setLoading(false);
  }, [countryCode, featureFlags, allFeaturesLoading]);

  return { countryFlags, loading, error };
}

const extractCountryFlags = (countryCode: string, featureFlags?: CrmisFeatureFlags): CrmisCountryFlags | undefined => {
  if (countryCode === '') return undefined;
  if (!featureFlags) return undefined;

  const flagsForCountry = {} as CrmisCountryFlags;
  Object.keys(featureFlags).forEach((feature) => {
    // if it's feature flag enabled per country, check that requested country is in array
    if (Array.isArray(featureFlags[feature])) {
      flagsForCountry[feature] = (featureFlags[feature] as string[]).includes(
        countryCode.toUpperCase()
      );
      // if it's feature flag disabling/enabling for all countries it will be already a boolean
    } else {
      flagsForCountry[feature] = featureFlags[feature] as boolean;
    }
  });
  return flagsForCountry;
};

export default useCountryFeatureFlags;
